import { NgStyle } from "@angular/common";
import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { KundDetailsModalComponent } from "~app/features/forsaljning/kund/components/kund-details-modal/kund-details-modal.component";
import { IKundList } from "~app/features/forsaljning/kund/models/kundList";
import { KundListViewModel } from "~app/features/forsaljning/kund/models/kundListViewModel";
import { KundService } from "~app/features/forsaljning/kund/services/kund.service";
import { IKundDetail } from "../../models/kundDetail";

@Component({
    selector: "rask-kund-list",
    templateUrl: "./kund-list.component.html",
    styleUrls: ["./kund-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ListComponent,
        ListColumnDirective,
        NgStyle,
        TranslatePipe
    ]
})
export class KundListComponent {
    kunder: KundListViewModel[] = [];

    private readonly busyService = inject(BusyService);
    private readonly kundService = inject(KundService);
    private readonly ngbModalService = inject(NgbModal);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("kunder") set list(val: any) {
        if (!val) {
            return;
        }
        this.kunder = val.kontaktKundList.map((x: IKundList) => new KundListViewModel(x));
    }

    getKundListFromDetail(updatedKund: IKundDetail): IKundList {
        return {
            aktiv: updatedKund.aktivLime,
            avdelning: updatedKund.avdelning,
            beskrivning: updatedKund.beskrivning,
            besokPostortadress: updatedKund.besokPostortadress,
            huvudkod: updatedKund.huvudkod,
            id: updatedKund.id,
            internnummer: updatedKund.internnummer,
            namn: updatedKund.namn,
            orgNummer: updatedKund.orgNummer,
            befraktare: updatedKund.befraktare,
            doljForKundorder: updatedKund.doljForKundorder,
            color: updatedKund.color
        };
    }

    showDetails(event: Event, kund: KundListViewModel): void {
        event.preventDefault();
        if (!kund || !kund.id) {
            return;
        }

        this.busyService.addWork(this.kundService.getKundById(kund.id))
            .subscribe(result => {
                if (result) {
                    const modalRef = this.ngbModalService.open(KundDetailsModalComponent, {
                        keyboard: false,
                        backdrop: "static",
                        size: "lg"
                    });
                    const model = modalRef.componentInstance as KundDetailsModalComponent;
                    model.data = result;
                    modalRef.result.finally( () => {
                        // Superbad. Återigen ett tecken på att man behöver en snyggare hanteringar av modal som har stöd för många olika scenarion.
                        // Bland annat att på något vis vänta in sparat resultat.
                        setTimeout(() => {
                            // eslint-disable-next-line sonarjs/no-nested-functions
                            this.kundService.getKundById(kund.id).subscribe(updatedKund => {
                                const kindex = this.kunder.indexOf(kund);
                                const kundArrCopy = [...this.kunder];
                                kundArrCopy.splice(kindex, 1, new KundListViewModel(this.getKundListFromDetail(updatedKund)));
                                this.kunder = kundArrCopy;
                            });
                        }, 200);
                    });
                }
            });
    }
}
